import FullScreenCard from './Fullscreen';

export default FullScreenCard;
export { default as BsPanel } from './Bootstrap';
export { default as InxPanel } from './NewStyle';
